import type { FC } from 'react'

import { Flex } from '@/components'
import iconLogoSvg from '@/img/logo.svg'
import { useAuthStore } from './store'
import { profile } from '@/profile'
import {
  IncomingCallOrSms,
  InitialScreen,
  OutgoingCall,
} from './steps'


export const AuthPage: FC = () => {
  const currentStep = useAuthStore((s) => s.currentStep)


  return <>
    <Flex
      gap={20}
      justify='center'
      align='center'
      vertical
      style={{ padding: '0 20px' }}
    >
      <img
        src={profile.isLogoEye ? '/vsem/assets/images/logo.svg' : iconLogoSvg}
        style={{ width: '50%', marginBottom: '26px' }}
      />

      {currentStep === 'initialScreen' && (
        <InitialScreen />
      )}

      {currentStep === 'outgoingCall' && (
        <OutgoingCall />
      )}

      {currentStep === 'incomingCallOrSms' && (
        <IncomingCallOrSms />
      )}
    </Flex>
  </>
}
